import ExceptionWebAPIUtils from '../utils/ExceptionWebAPIUtils';
export default {
    getOrderExceptions(query) {
        ExceptionWebAPIUtils.getOrderExceptions(query);
    },
    getExceptions(query) {
        ExceptionWebAPIUtils.getExceptions(query);
    },
    getShipperExceptions(query) {
        ExceptionWebAPIUtils.getShipperExceptions(query);
    },
    addResolution(exceptionId, message, meta = {}) {
        ExceptionWebAPIUtils.addResolution(exceptionId, "manual", message, meta);
    },
    bulkResolve(exceptionIds) {
        ExceptionWebAPIUtils.bulkResolve(exceptionIds);
    },
    updateException(payload) {
        ExceptionWebAPIUtils.updateException(payload);
    },
};
